module.exports = __webpack_public_path__ + "img/logofs.6cdca618.svg";